import { createFileRoute, useParams } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { OrderDetailPage } from '@/features/orders/OrderDetailPage';
import { MobileOrderDetail } from '@/features/orders/mobile/MobileOrderDetail';

export const Route = createFileRoute('/_app/orders/$orderId')({ component: OrderDetail });

function OrderDetail() {
  const { orderId } = useParams({ from: '/_app/orders/$orderId' });
  const isMobile = useIsMobileShell();
  /* I campi sono gli stessi (li rendono `OrderDataTab`/`OrderLinesTab`, già a una colonna sotto
     i 768px): a cambiare è il contorno — header di schermata, indicatori a due colonne e
     segmento al posto delle pastiglie. */
  return isMobile ? <MobileOrderDetail orderId={orderId} /> : <OrderDetailPage orderId={orderId} />;
}
